import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dropdown, Badge, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookMessenger } from '@fortawesome/free-brands-svg-icons';
import { useAuth } from './../Context/AuthContext';
import moment from 'moment';
import { BASE_URL } from '../constants';
const Messages = () => {
  const { user } = useAuth();
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchNotifications = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetch(`${BASE_URL}/users/notifications/messages/${user.id}`);
      const data = await response.json();
      setNotifications(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Error fetching notifications:', error);
    } finally {
      setLoading(false);
    }
  }, [user.id]);

  useEffect(() => {
    if (user?.id) {
      fetchNotifications();
    }
  }, [fetchNotifications, user?.id]);

  const handleNotificationClick = async (notificationId) => {
    try {
      const notification = notifications.find((n) => n._id === notificationId);
      if (!notification) return;
  
      // PATCH request to mark the notification as read
      await fetch(`${BASE_URL}/users/mark-read/${notificationId}`, {
        method: 'PATCH',
        headers: {
          'Authorization': `Bearer ${user.token}`,
          'Content-Type': 'application/json',
        },
      });
  
      // Refresh notifications and unread count
      fetchNotifications();
  
      // Navigate to chat
      navigate('/chat');
    } catch (error) {
      console.error('Error marking notification as read:', error);
    }
  };
  
  
  
  const unreadCount = Array.from(
    new Set(
      notifications.filter((n) => !n.isRead).map((n) => n.senderId)
    )
  ).length;

  const groupedNotifications = notifications.reduce((acc, notif) => {
    const { senderId } = notif;
    if (!acc[senderId]) {
      acc[senderId] = {
        senderId,
        messages: [],
      };
    }
    acc[senderId].messages.push(notif);
    return acc;
  }, {});

  return (
    <Dropdown className="ms-3 notification-wrapper">
         <Dropdown.Toggle
        as="button"
        variant="outline-primary"
        className="p-0 position-relative"
        style={{
          backgroundColor: 'transparent',
          border: 'none',
          boxShadow: 'none',
        }}
      >
        <FontAwesomeIcon icon={faFacebookMessenger} className="text-white" />
        {!loading && unreadCount > 0 && (
          <span
            className="position-absolute top-0 start-100 translate-middle badge rounded-pill"
            style={{
              backgroundColor: '#0084FF', 
              color: '#fff',
              fontSize: '0.7rem',
              padding: '4px 6px',
              boxShadow: '0 0 0.25rem rgba(0, 0, 0, 0.3)',
            }}
          >
            {unreadCount}
          </span>
        )}
      </Dropdown.Toggle>

      <Dropdown.Menu
        className="notification-dropdown mt-2"
        style={{
          minWidth: '320px',
          maxHeight: '400px',
          overflowY: 'auto',
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        }}
      >
        <div className="p-3 border-bottom fw-bold text-uppercase text-muted small">
          Messages 
        </div>

        {loading ? (
          <div className="text-center py-3">
            <Spinner animation="border" size="sm" />
          </div>
        ) : Object.keys(groupedNotifications).length === 0 ? (
          <Dropdown.Item className="text-center py-3 text-muted">No new messages</Dropdown.Item>
        ) : (
          Object.values(groupedNotifications).map(({ senderId, messages }) => {
            const unreadMessages = messages.filter(m => !m.isRead);
            const latestMessage = messages.sort(
              (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
            )[0];

            return (
              <div key={senderId}>
                <Dropdown.Item
                  className="d-flex flex-column px-3 py-2"
                  style={{
                    backgroundColor: unreadMessages.length > 0 ? '#fff' : '#f8f9fa',
                    color: unreadMessages.length > 0 ? '#212529' : '#6c757d',
                    cursor: 'pointer',
                  }}
                  onClick={() => handleNotificationClick(latestMessage._id)}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <div style={{ fontWeight: unreadMessages.length > 0 ? '600' : '400' }}>
                      {latestMessage.message}
                    </div>
                 
                  </div>
                  <small className="text-muted">
                    {moment(latestMessage.createdAt).fromNow()}
                  </small>
                </Dropdown.Item>
                <div className="border-top mx-3" />
              </div>
            );
          })
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default Messages;
